import React from "react";
import { useParams, useHistory } from "react-router-dom";
import { MEDIA_TYPES } from "../../../constants/app-constant";
import { FEED_DETAILS } from "../../../constants/route-constants";
import { BackBtnArrow, ForwardBtnArrow } from "../../Icons/icons.component";

export default function NextPrevArrows({
  isPrint,
  isOnline,
  isSocial,
  isBlogsAndForums,
  entityName,
  otherEdition,
}) {
  const { articleIdentifier, channel_type, id } = useParams();
  const [clientId, channelType] =
    (channel_type && channel_type.split("-")) || [];
  const history = useHistory();
  let mTypePrefix = isPrint ? MEDIA_TYPES.PRINT_MV : "";
  mTypePrefix = isOnline ? MEDIA_TYPES.ONLINE_MV : mTypePrefix;
  mTypePrefix = isSocial ? MEDIA_TYPES.SOCIAL_MV : mTypePrefix;
  mTypePrefix = isBlogsAndForums ? MEDIA_TYPES.BLOG_MV : mTypePrefix;
  const a = JSON.parse(localStorage.getItem("articleIdList"));
  if (!a || a.length < 2) {
    return null;
  }
  /* This is the format of article identifier stored in local storage, used to handle next/prev navigation.
   The code below get the current index of article viewed so that the immediate next/prev  article can be fetched relative
   to position of currently viewed article **/
  let currentIndex = a.indexOf(`${mTypePrefix}/${articleIdentifier}`);
  if (isSocial || isBlogsAndForums) {
    const socialArticleIdentifier = `${channelType}/${id}?entityName="${entityName}"`;
    currentIndex = a.indexOf(socialArticleIdentifier);
  } else if (currentIndex === -1) {
    const ele = otherEdition && a.find((x) => otherEdition.indexOf(x) !== -1);
    if (ele) {
      currentIndex = a.indexOf(ele);
    }
  }
  const handlePagination = (e, type) => {
    if (type === "+") {
      currentIndex = currentIndex + 1;
    }
    if (type === "-") {
      currentIndex = currentIndex - 1;
    }
    if (isSocial || isBlogsAndForums) {
      history.push(
        `${FEED_DETAILS}/${mTypePrefix}/${clientId}-${a[currentIndex]}`
      );
      return;
    }
    history.push(`${FEED_DETAILS}/${a[currentIndex]}`);
  };
  return (
    <React.Fragment key={currentIndex}>
      <button
        disabled={currentIndex === 0}
        onClick={(e) => handlePagination(e, "-")}
        className="prevArrow"
        style={{ marginLeft: "85px" }}
      >
        <div className="hasTooltip">
          <BackBtnArrow />
          <span className="tooltipWrap left">Previous</span>
        </div>
      </button>
      <button
        disabled={currentIndex === a.length - 1}
        onClick={(e) => handlePagination(e, "+")}
        className="nextArrow"
      >
        <div className="hasTooltip">
          <ForwardBtnArrow />
          <span className="tooltipWrap right">Next</span>
        </div>
      </button>
    </React.Fragment>
  );
}
